module.exports = __webpack_public_path__ + "static/img/animales_37.7fc373f8.png";